import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Camera, Save, Settings as SettingsIcon } from "lucide-react";

export default function AdminConfig() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.patch("/settings", { photo_required_on_delivery: settings.photo_required_on_delivery });
      setSettings(r.data);
      toast.success("Configuración guardada");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  if (!settings) return <Layout><div className="text-zinc-500 font-mono-tech">Cargando...</div></Layout>;

  return (
    <Layout>
      <div className="mb-8">
        <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-2">/ Sistema</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">Configuración</h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">Ajustes globales que afectan a toda la operación. Cada cliente puede sobrescribir estos valores en su ficha.</p>
      </div>

      <div className="max-w-3xl">
        <div className="border border-white/10 bg-zinc-900/40 p-8 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <Camera className="w-6 h-6 text-yellow-300" />
            <div>
              <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest">/ Evidencia de entrega</div>
              <div className="font-display font-bold text-xl mt-1">Foto obligatoria al entregar</div>
            </div>
          </div>
          <p className="text-zinc-400 text-sm mb-6">
            Si está activado, el repartidor <b className="text-white">no puede marcar como entregado</b> sin subir la foto. Cada cliente/aliado puede sobrescribir esta configuración desde su ficha (Clientes → Editar).
          </p>
          <label className="flex items-center gap-4 cursor-pointer p-4 border border-white/10 hover:border-yellow-300/40 transition-colors" data-testid="toggle-photo-required">
            <div className={`w-14 h-7 relative transition-colors ${settings.photo_required_on_delivery ? "bg-yellow-300" : "bg-zinc-700"}`}>
              <div className={`absolute top-0.5 w-6 h-6 bg-black transition-transform ${settings.photo_required_on_delivery ? "translate-x-7" : "translate-x-0.5"}`} />
            </div>
            <input type="checkbox" checked={!!settings.photo_required_on_delivery} onChange={(e) => setSettings({ ...settings, photo_required_on_delivery: e.target.checked })} className="hidden" />
            <div className="flex-1">
              <div className="font-medium">{settings.photo_required_on_delivery ? "Obligatoria (por defecto)" : "Opcional"}</div>
              <div className="text-xs text-zinc-500 mt-0.5 font-mono-tech uppercase tracking-widest">
                {settings.photo_required_on_delivery ? "El repartidor debe capturar foto para completar la entrega" : "El repartidor puede saltar la foto si lo desea"}
              </div>
            </div>
          </label>
        </div>

        <button onClick={save} disabled={saving} className="bg-yellow-300 text-black font-bold px-6 py-3 uppercase tracking-widest text-sm hover:bg-yellow-200 inline-flex items-center gap-2 disabled:opacity-50" data-testid="save-settings">
          <Save className="w-4 h-4" /> {saving ? "Guardando..." : "Guardar cambios"}
        </button>
      </div>
    </Layout>
  );
}
